import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getData = (state: AppState) => state.changePassword;
const getResponseCreate = (state: AppState) => state.changePassword.responseCreate;
const getResponseAuth = (state: AppState) => state.changePassword.responseAuth;

export const getChangePasswordSelector = createSelector(getData, (data) => data);
export const getChangePasswordCreateSelector = createSelector(getResponseCreate, (data) => data);
export const getChangePasswordAuthSelector = createSelector(getResponseAuth, (data) => data);
